import { Component } from 'react';
import { withTranslation } from 'react-i18next';

class AdditionalBox extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;
        return (
            <>
                <div className="table-additional-view">
                    <div className="table-additional-view-btns">
                        <div className="table-additional-view-btn-groups">
                            <button
                                className={`${
                                    (!this.props.view || this.props.view === 1) && 'active'
                                }`}
                                onClick={() => this.props.chooseView(1)}
                            >
                                {t('discover.competitive_analysis.nested_view')}
                            </button>
                            <button
                                className={`${this.props.view === 2 && 'active'}`}
                                onClick={() => this.props.chooseView(2)}
                            >
                                {t('discover.competitive_analysis.2nd_level')}
                            </button>
                            <button
                                className={`${this.props.view === 3 && 'active'}`}
                                onClick={() => this.props.chooseView(3)}
                            >
                                {t('discover.competitive_analysis.3rd_level')}
                            </button>
                        </div>
                        {this.props.hasTree && (
                            <button
                                type="button"
                                className="table-additional-view-btn"
                                onClick={() => {
                                    // check if "all categories" is open or not
                                    if (!this.props.tree.state.ids.includes('all_categories')) {
                                        this.props.tree.fns.onToggleById('all_categories');
                                    }

                                    // minus 1 because ids doesn't include 'all_categoris'
                                    // this one for closing all
                                    if (
                                        this.props.tree.state.ids.length - 1 ===
                                        this.props.ids.current?.length
                                    ) {
                                        return this.props.ids.current.forEach((id) =>
                                            this.props.tree.fns.onToggleById(id),
                                        );
                                    }

                                    //this one for opening all
                                    this.props.ids.current?.forEach((id) => {
                                        if (!this.props.tree.state.ids.includes(id)) {
                                            this.props.tree.fns.onToggleById(id);
                                        }
                                    });
                                }}
                            >
                                {this.props.tree.state.ids.length - 1 ===
                                this.props.ids.current?.length
                                    ? t('discover.competitive_analysis.collaps_all')
                                    : t('discover.competitive_analysis.expand_all')}
                            </button>
                        )}
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation()(AdditionalBox);
